import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from '../../../material.module';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, interval, Subscription, take } from 'rxjs';

@Component({
  selector: 'app-page-403',
  imports: [RouterModule, MaterialModule],
  templateUrl: './page-403.component.html',
})
export class Page403Component implements OnInit, OnDestroy {
  private checkSubscription?: Subscription;
  private readonly CHECK_INTERVAL = 3000; // Vérifier toutes les 3 secondes
  private readonly MAX_CHECKS = 200; // Maximum 200 vérifications (10 minutes)

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Vérifier immédiatement lors de l'initialisation
    this.checkAccess();

    // Vérifier périodiquement toutes les 3 secondes, jusqu'à 200 vérifications (10 minutes)
    this.checkSubscription = interval(this.CHECK_INTERVAL)
      .pipe(take(this.MAX_CHECKS))
      .subscribe(() => {
        this.checkAccess();
      });
  }

  ngOnDestroy(): void {
    if (this.checkSubscription) {
      this.checkSubscription.unsubscribe();
    }
  }

  private checkAccess(): void {
    // Faire une requête HEAD vers un endpoint API pour vérifier l'accès
    // Si la requête réussit (pas de 403), rediriger vers le dashboard
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    // Utiliser un endpoint API simple pour vérifier l'accès IP
    // Le hook IP_check vérifie l'IP avant même d'atteindre le contrôleur
    // Si l'IP n'est pas autorisée, on recevra un 403
    this.http.head(environment.serverUrl + 'kpi/get_dashboard_sales', { 
      headers, 
      observe: 'response',
      withCredentials: true
    })
      .pipe(
        catchError((error: any) => {
          // Si l'erreur est un 403, l'accès est toujours refusé, on reste sur la page
          // Si l'erreur n'est pas un 403 (401, 500, etc.), cela signifie que l'IP est autorisée
          // car le hook IP_check n'a pas bloqué la requête
          if (error.status !== 403 && error.status !== 0) {
            // L'IP est autorisée, rediriger vers le dashboard
            this.redirectToDashboard();
          }
          // Si status 0, c'est probablement une erreur réseau, on ignore
          return [];
        })
      )
      .subscribe({
        next: (response) => {
          // Si la requête réussit (status 200-299), l'accès est autorisé
          if (response && response.status >= 200 && response.status < 300) {
            this.redirectToDashboard();
          } else if (response && response.status !== 403) {
            // Si la réponse n'est pas un 403, l'IP est autorisée
            this.redirectToDashboard();
          }
        }
      });
  }

  private redirectToDashboard(): void {
    // Arrêter la vérification
    if (this.checkSubscription) {
      this.checkSubscription.unsubscribe();
    }
    // Rediriger vers le dashboard
    this.router.navigate(['/pages-dashboard']);
  }
}

